import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-expansion-date-panel',
  templateUrl: './expansion-date-panel.component.html',
  styleUrls: ['./expansion-date-panel.component.scss', './expansion-date-panel.component.en.scss'],
})
export class ExpansionDatePanelComponent {
    @Input({ required: true }) title?: string;
    @Input() startDatePlaceHolder: string = '';
    @Input() endDatePlaceHolder: string = '';
    @Input({ required: true }) fromDate!: Date | null;
    @Input({ required: true }) toDate!: Date | null;
    @Input() disabled: boolean = false;

    @Output() fromDateChanged = new EventEmitter<Date>();
    @Output() toDateChanged = new EventEmitter<Date>();

    changeDateFrom(event: Date) {
        this.fromDateChanged.emit(event);
    }

    changeDateTo(event: Date) {
        this.toDateChanged.emit(event);
    }
}